import React, { useState } from 'react';
import { connect } from 'react-redux';
import SortButton from '../../Buttons/SortButton';

import '../text_wrapper.scss';

import { getDocumentRelationships } from '../../../store/Document/documentActions';
import { useEffect } from 'react';
import Loader from '../../Loader';
import { ROUTES } from '../../../assets/constants/strings';
import { Link } from 'react-router-dom';

const RelatedDocuments = ({
  currentDoc,
  relatedDocuments,
  getDocumentRelationships,
}) => {
  useEffect(() => {
    if (!relatedDocuments)
      getDocumentRelationships(currentDoc.id);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [currentDoc, relatedDocuments]);

  const [isAscending, setIsAscending] = useState(true);
  if (!relatedDocuments) {
    return (
      <Loader card />
    );
  }
  else {
    // no related documents
    if (relatedDocuments && relatedDocuments.length < 1) {
      return <p className="mb-0">No related documents</p>;
    }
    // one related document
    else if (relatedDocuments && relatedDocuments.length < 2) {
      return (
        <React.Fragment>
          {relatedDocuments.map((relatedDocument, index) => (
            <Link
              key={index}
              to={ROUTES.DOCUMENT(relatedDocument.isParent ? relatedDocument.doc2Slug : relatedDocument.doc1Slug)}
              target="_blank"
              rel="noreferrer"
            >
              <div className="wf-card__item__wrapper">
                <p title={relatedDocument.isParent ? relatedDocument.doc2Title : relatedDocument.doc1Title}>
                  {relatedDocument.isParent ? relatedDocument.doc2Title : relatedDocument.doc1Title}
                </p>
              </div>
            </Link>
          ))}
        </React.Fragment>
      );
    }
    // more than one related document
    else if (relatedDocuments && relatedDocuments.length > 1) {
      const handleOrder = () => {
        const isAsc = !isAscending;
        setIsAscending(isAsc);

        relatedDocuments = isAsc === true ? (
          relatedDocuments.sort((a, b) => (a.isParent && b.isParent) ? (
            // if its parent, the displayed doc is doc2
            a.doc2Title.localeCompare(b.doc2Title, undefined, { numeric: true })
          ) : (
            a.doc1Title.localeCompare(b.doc1Title, undefined, { numeric: true }))
          )
        ) : (
          relatedDocuments.sort((a, b) => (a.isParent && b.isParent) ? (
            // if its parent, the displayed doc is doc2
            b.doc2Title.localeCompare(a.doc2Title, undefined, { numeric: true })
          ) : (
            b.doc1Title.localeCompare(a.doc1Title, undefined, { numeric: true })
          ))
        );
      };

      return (
        <div className="sortable-wrapper">
          <div className="sortable-wrapper__list">
            {relatedDocuments.map((relatedDocument, index) =>
              relatedDocument.isParent ? (
                <Link
                  key={index}
                  to={ROUTES.DOCUMENT(relatedDocument.doc2Slug)}
                  target="_blank"
                  rel="noreferrer"
                >
                  <div className="wf-card__item__wrapper">
                    <p title={relatedDocument.doc2Title}>{relatedDocument.doc2Title}</p>
                  </div>
                </Link>
              ) : (
                // if the parent type relationships dont already display this doc
                relatedDocuments.filter((rel) => rel.doc2Id === relatedDocument.doc1Id).length <
                1 && (
                  <Link
                    key={index}
                    to={ROUTES.DOCUMENT(relatedDocument.doc1Slug)}
                    target="_blank"
                    rel="noreferrer"
                  >
                    <div className="wf-card__item__wrapper">
                      <p title={relatedDocument.doc1Title}>{relatedDocument.doc1Title}</p>
                    </div>
                  </Link>
                )
              )
            )}
          </div>
          <div className="sortable-wrapper__button">
            <SortButton handleOrder={handleOrder} sort={isAscending === true ? '>' : '<'} small />
          </div>
        </div>
      );
    }
  }
};

const mapStateToProps = (state) => ({
  relatedDocuments: state.document.relatedDocuments,
  currentDoc: state.document.currentDocument,
});

const mapDispatchToProps = { getDocumentRelationships };

const connector = connect(mapStateToProps, mapDispatchToProps);

export default connector(RelatedDocuments);
